import type { SupportedRepubName } from './types';

export type MatchupCentreConfig = {
  defaultEventDisplayName: string;
  matchCenterLabel: string;
  matchCenterPath: string;
};

/**
 * Matchup Centre configurations for each republic
 */
export const MATCHUP_CENTRE_CONFIGS = {
  GZ: {
    // TODO: Revert to 'Serie A' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
    matchCenterLabel: 'Match Center',
    matchCenterPath: 'match-centre',
  },
  OC: {
    // TODO: Revert to 'EPL' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
    matchCenterLabel: 'Match Centre',
    matchCenterPath: 'match-centre',
  },
  US: {
    // TODO: Revert to 'NFL' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
    matchCenterLabel: 'Match Center',
    matchCenterPath: 'match-center',
  },
  WS: {
    // TODO: Revert to 'All' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
    matchCenterLabel: 'Match Centre',
    matchCenterPath: 'match-centre',
  },
} satisfies Record<SupportedRepubName, MatchupCentreConfig>;
